export default __webpack_public_path__ + "static/media/ganpatiLeftBanner.22fd5107.png";